export interface Invoice {
    date: Date;
    description: string;
    id: string;
    noSociete: string;
    statut: string;
    totalAmount: string;
}

export class ReceiptModel {
    abrCreditCard: string;
    amount: string;
    date: Date;
    message: string;
    nameUnderCard: string;
    numConfirmation: string;
    orderId: string;
    responseIsoCode: string;
    result: string;
    sequence: string;
    typeTransactionRefMoneris: string;
    invoices: Invoice[];
    metadata: any;
}
